import { render, staticRenderFns } from "./UploadedMedFiles.vue?vue&type=template&id=4d33dbb1&scoped=true&"
import script from "./UploadedMedFiles.vue?vue&type=script&lang=js&"
export * from "./UploadedMedFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploadedMedFiles.vue?vue&type=style&index=0&id=4d33dbb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33dbb1",
  null
  
)

export default component.exports